import EventHandler, { EventName } from './eventHandler';

const eventHandler = new EventHandler();

export { EventName };
export default eventHandler;
